import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { hasPrivilege, USER_WRITE } from 'utils/privileges';
import { useFetchPlaylistsAudienceById } from 'actions/playlists';
import { useAppNameContext } from 'hooks/useAppNameContext';
import TextLink from 'components/TextLink';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import InlineList from 'components/InlineList';
import Stack from 'components/Stack';
import Text from 'components/Text';
import { AdminPill, EveryonePill, TeamPill } from 'components/Pill';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AudienceOverview(_ref) {
  var audience = _ref.audience,
    teamsList = _ref.teamsList;
  var canUserAccessTeams = hasPrivilege(USER_WRITE);
  var filteredTeams = teamsList.filter(function (team) {
    return !team.isCalculated;
  });
  if (audience === 'admin') {
    return /*#__PURE__*/_jsx(AdminPill, {});
  }
  if (audience === 'all') {
    return /*#__PURE__*/_jsx(EveryonePill, {});
  }
  if (audience === 'teams') {
    return /*#__PURE__*/_jsx(InlineList, {
      spacing: "xxs",
      children: filteredTeams.map(function (team) {
        var teamId = team.id;
        var link = "/teams?search=".concat(encodeURIComponent("id:".concat(teamId)));
        return canUserAccessTeams ? /*#__PURE__*/_jsx(AdminOrHubTextLink, {
          bold: true,
          link: link,
          children: /*#__PURE__*/_jsx(TeamPill, {
            team: team
          }, teamId)
        }, teamId) : /*#__PURE__*/_jsx(TeamPill, {
          team: team
        }, teamId);
      })
    });
  }
  return null;
}
function PlaylistsTeamsDropdown(_ref2) {
  var playlist = _ref2.playlist,
    parentPlaylists = _ref2.parentPlaylists,
    children = _ref2.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var appNameContext = useAppNameContext();
  var _useFetchPlaylistsAud = useFetchPlaylistsAudienceById({
      playlistIds: parentPlaylists.map(function (playlist) {
        return playlist.id;
      })
    }),
    parentPlaylistsWithTeams = _useFetchPlaylistsAud.items;
  var parentPlaylistsItems = parentPlaylistsWithTeams === null || parentPlaylistsWithTeams === void 0 ? void 0 : parentPlaylistsWithTeams.map(function (playlist) {
    var playlistId = playlist.id,
      name = playlist.name,
      audience = playlist.audience,
      teams = playlist.teams;
    var adminLink = "/admin/playlists/".concat(playlistId);
    var hubLink = "/playlists/".concat(playlistId);
    var playlistLink = appNameContext === 'hub' ? hubLink : adminLink;
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      my: "s",
      children: [/*#__PURE__*/_jsx(TextLink, {
        href: playlistLink,
        stealthy: true,
        children: name
      }), /*#__PURE__*/_jsx(AudienceOverview, {
        audience: audience,
        teamsList: teams
      })]
    }, playlistId);
  });
  var selectedPlaylistItem = /*#__PURE__*/_jsxs(Stack, {
    spacing: "xs",
    my: "s",
    children: [/*#__PURE__*/_jsx(Text, {
      children: t('playlist_access_this_playlist')
    }), /*#__PURE__*/_jsx(AudienceOverview, {
      audience: playlist.audience,
      teamsList: playlist.teams
    })]
  }, playlist.id);
  var listItems = [selectedPlaylistItem].concat(_toConsumableArray(parentPlaylistsItems));
  return /*#__PURE__*/_jsx(DetailsDropdown, {
    titleKey: "playlist_access_audience_overview_title",
    listItems: listItems,
    listLayout: "stack",
    children: children
  });
}
export default PlaylistsTeamsDropdown;